import React, { useState, useEffect } from "react";
import Input from "../../components/Input";
import InputSelect from "../../components/InputSelect";
import InputDate from "../../components/InputDate";
import InputMask from "../../components/InputMask";
import { Row, Col, Typography } from "antd";
import { LoadingOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { normalizeText } from "../../utils/removeMask";
import InputCheckbox from "../../components/InputCheckbox";

const docId = {
  personTaxId: { name: "personTaxId", label: "CPF" },
  personRG: { name: "personRG", label: "RG" },
  personRNE: { name: "personRNE", label: "RNE" },
};

export default function FormPersonal({
  register,
  control,
  errors,
  onPrevious,
  onNext,
  loading,
  getValues,
  setValue,
}) {
  const [identificationTypeSelected, setIdentificationTypeSelected] =
    React.useState("");

  function fnRemoveCaracter(e) {
    return normalizeText(e.target.value);
  }

  useEffect(() => {
    const { taxIdType } = getValues();
    if (taxIdType) {
      setIdentificationTypeSelected(taxIdType);
    } else {
      setIdentificationTypeSelected("personTaxId");
    }
  }, []);

  return (
    <div key="formPersonal">
      <Row gutter={16} className="__auth-mb-25">
        <Col xs={24}>
          <div style={{ margin: "0px 10px", marginBottom: "40px" }}>
            <Typography.Title level={4}>
              Para abertura de sua conta PJ precisamos qua a mesma tenha UM
              representante com poderes isolados para abrir, movimentar e
              encerrar a conta.
            </Typography.Title>
            <Typography.Title level={4}>
              Preencha com os dados do administrador da sua conta PJ
            </Typography.Title>
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            label="Nome"
            placeholder="Digite o seu nome completo"
            register={register("fullName")}
            required
            error={errors.fullName?.message}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <InputMask
            name="personTaxId"
            type="tel"
            control={control}
            label="Documento"
            placeholder={
              docId[identificationTypeSelected]?.label &&
              `Digite o seu ${docId[identificationTypeSelected]?.label}`
            }
            mask={
              identificationTypeSelected === "personTaxId"
                ? "999.999.999-99"
                : null
            }
            maskChar={null}
            required
            error={errors.personTaxId?.message}
            adornment={
              <div className="__auth-flex-column">
                <div className="__auth-flex-row" style={{ marginLeft: "10px" }}>
                  <div className="__auth-radio-item">
                    <input
                      type="radio"
                      id="selectCPF"
                      register={register("taxIdType")}
                      value="CPF"
                      readOnly
                      onClick={() => {
                        setIdentificationTypeSelected("personTaxId");
                        setValue("taxId", "");
                        setValue("taxIdType", "personTaxId");
                      }}
                      checked={identificationTypeSelected === "personTaxId"}
                    />
                    <label htmlFor="selectCPF">
                      {docId["personTaxId"]?.label}
                    </label>
                  </div>
                  <div className="__auth-radio-item">
                    <input
                      type="radio"
                      id="selectRG"
                      value="personRG"
                      readOnly
                      onClick={() => {
                        setIdentificationTypeSelected("personRG");
                        setValue("personTaxId", "");
                        setValue("taxIdType", "personRG");
                      }}
                      checked={identificationTypeSelected === "personRG"}
                    />
                    <label htmlFor="selectRG">{docId["personRG"]?.label}</label>
                  </div>
                  <div className="__auth-radio-item">
                    <input
                      type="radio"
                      id="selectRNE"
                      value="personRNE"
                      readOnly
                      onClick={() => {
                        setIdentificationTypeSelected("personRNE");
                        setValue("taxId", "");
                        setValue("taxIdType", "personRNE");
                      }}
                      checked={identificationTypeSelected === "personRNE"}
                    />
                    <label htmlFor="selectRNE">
                      {docId["personRNE"]?.label}
                    </label>
                  </div>
                </div>
              </div>
            }
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <InputDate
            label="Data de nascimento"
            placeholder="Digite a data de nascimento"
            control={control}
            required
            name="birthDate"
            maxDate={new Date()}
            minDate={new Date("1700")}
            error={errors.birthDate?.message}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <div key="divInput">
            <Input
              key="inputEmail"
              label="Email pessoal"
              placeholder="Digite o seu email"
              register={register("personalEmail", {
                setValueAs: (value) => value.replace(/ /g, ""),
              })}
              required
              error={errors.personalEmail?.message}
            />
          </div>
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <InputMask
            key="mobile1"
            type="tel"
            label="Celular"
            placeholder="Digite seu número de celular"
            control={control}
            name="mobile1"
            mask="(99) 99999-9999"
            maskChar={null}
            required
            error={errors.mobile1?.message}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <InputSelect
            control={control}
            key="personRoleType"
            label="Tipo de função"
            placeholder="Selecione o tipo de função"
            name="personRoleType"
            required
            error={errors.personRoleType?.message}
            options={[
              { value: "0", label: "Titular" },
              { value: "1", label: "Procurador" },
              { value: "2", label: "Portador" },
              { value: "3", label: "Associado" },
            ]}
          />
        </Col>
        {/* <Col xs={24} sm={24} md={12} lg={12}>
          <InputSelect
            control={control}
            key="pep"
            label="Pessoa Exposta Politicamente"
            placeholder=""
            name="pep"
            required
            error={errors.pep?.message}
            options={[
              { value: false, label: "Não" },
              { value: true, label: "Sim" },
            ]}
          />
        </Col> */}
        <Col xs={24} sm={24} md={12} lg={12}>
          <InputSelect
            control={control}
            key="maritalStatus"
            label="Estado Civil"
            placeholder=""
            name="maritalStatus"
            required
            error={errors.maritalStatus?.message}
            options={[
              { value: "0", label: "União Estavel" },
              { value: "1", label: "Casado(a)" },
              { value: "2", label: "Divorciado(a)" },
              { value: "3", label: "Separado(a) Judicialmente" },
              { value: "4", label: "Viúvo(a)" },
              { value: "5", label: "Solteiro(a)" },
              { value: "6", label: "Outros" },
            ]}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <InputSelect
            control={control}
            key="gender"
            label="Gênero"
            placeholder="Selecione seu gênero"
            name="gender"
            required
            error={errors.gender?.message}
            options={[
              { value: "0", label: "Masculino" },
              { value: "1", label: "Feminino" },
              { value: "2", label: "Outros" },
            ]}
          />
        </Col>
        <Col xs={24} sm={24} style={{display: "none"}}>
         {/*  <Input            
            key="inputIndication"
            label="Código de convidado"
            placeholder="Digite o código de indicação se possuir"
            register={register("indication")}
            error={errors.indication?.message}
            adornment={
              <div className="__auth-terms">
                <p style={{ marginLeft: "20px", marginBottom: "0" }}>
                  *opcional
                </p>
              </div>
            }
          /> */}
        </Col>

        
        <InputCheckbox
          label="PPE"
          register={register("pep")}
          name="pep"
          error={errors.pep?.message}
          adornment={
            <>
              <div style={{ margin: "10px 5px 0px" }}>
                <strong style={{ display: "flex", margin: "16px 0" }}>
                  Pessoa politicamente Exposta - ao menos um dos sócios ou
                  acionistas pode ser considerado:
                </strong>
                <p>
                  Pessoa que tenha desempenhado, nos últimos 5 anos, no Brasil
                  ou em outros países, cargos, empregos ou funções públicas
                  relevantes.
                </p>
              </div>
            </>
          }
        />

        <InputCheckbox
          label="Relação com PPE"
          register={register("pepRelationship")}
          name="pepRelationship"
          error={errors.pepRelationship?.message}
          adornment={
            <>
              <div style={{ margin: "10px 5px 0px" }}>
                <strong style={{ display: "flex", margin: "16px 0" }}>
                  Possui vínculo com Pessoa Politicamente Exposta
                </strong>
                <p>
                  Representantes, familiares ou pessoas de relacionamento com
                  pessoa que tenha desempenhado, nos últimos 5 anos, no Brasil
                  ou em outros países, cargos, empregos ou funções públicas
                  relevantes.
                </p>
              </div>
            </>
          }
        />
      </Row>
      <Row gutter={16} className="__signup-bottom-button">
        <Col xs={12}></Col>
        <Col xs={12}>
          <button
            type="button"
            className="__auth-button-primary"
            onClick={onNext}
            disabled={loading}
          >
            {loading ? <LoadingOutlined /> : "Próximo"}
          </button>
        </Col>
      </Row>
    </div>
  );
}
